import axios from "axios";
import { host } from "../../../helper/config";
import { encryptMessage } from "../../../helper/helper";
const PLUGINS_NAME = "admin-classic-input";

export const getList = async (token, filter) => {
  const { from, to, channelId, region, page } = filter || {};

  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-list`,
    {
      ...(from ? { from } : {}),
      ...(to ? { to } : {}),
      ...(channelId ? { channelId } : {}),
      ...(region ? { region } : {}),
      ...(page !== undefined ? { page } : {}),
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const getListTicket = async (token, resultId) => {
  const response = await axios.get(
    `${host}/${PLUGINS_NAME}/get-list-ticket?resultId=${resultId}`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const addPeriod = async (token, channel, date) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/add-period`,
    {
      channel: channel,
      date: date,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return false;
};

// Helper: Convert base64 to Blob
const base64ToBlob = (base64, mimeType = "image/jpeg") => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
};

export const addStorage = async (
  token,
  resultId,
  list,
  isDirectSale = false,
) => {
  try {
    const formData = new FormData();

    formData.append("resultId", resultId);
    formData.append("isDirectSale", isDirectSale ? "true" : "false");

    const listData = list.map((item, index) => ({
      numbers: item.numbers,
      amount: item.amount,
      imageIndex: item.images ? index : undefined,
    }));

    formData.append("list", JSON.stringify(listData));

    list.forEach((item, index) => {
      if (item.images) {
        if (item.images instanceof File) {
          formData.append(`image_${index}`, item.images, item.images.name);
        } else if (typeof item.images === "string" && item.images.length > 0) {
          // Handle base64 string from ImageUpload component
          const blob = base64ToBlob(item.images);
          formData.append(`image_${index}`, blob, `ticket_${index}.jpg`);
        }
      }
    });

    const response = await axios.post(`${host}/${PLUGINS_NAME}/add`, formData, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    });

    console.log("addStorage response:", response);
    if (response && response.status === 200) {
      return response.data || { success: true };
    }
    return { success: false, error: "Invalid response status" };
  } catch (error) {
    console.error("addStorage error:", error);
    // Extract error message from API response
    if (error.response && error.response.data) {
      const errorData = error.response.data;
      return {
        success: false,
        error: errorData.error || "Unknown error",
        message: errorData.message || error.message,
        duplicateNumbers: errorData.duplicateNumbers || [],
      };
    }
    return { success: false, error: error.message };
  }
};

export const confirmInput = async (token, resultId) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/submit`,
    {
      resultId: resultId,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const autoCreatePeriods = async (
  token,
  daysAhead = 2,
  region = "MN",
) => {
  try {
    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/auto-create-periods`,
      {
        daysAhead: daysAhead,
        region: region,
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: token,
        },
      },
    );

    if (response && response.status === 200) {
      return response.data || {};
    }
    return { success: false, error: "Invalid response status" };
  } catch (error) {
    console.error("autoCreatePeriods error:", error);
    return { success: false, error: error.message };
  }
};

export const addPairStorage = async (
  token,
  resultId,
  list,
  isDirectSale = false,
) => {
  try {
    const formData = new FormData();

    formData.append("resultId", resultId);
    formData.append("isDirectSale", isDirectSale ? "true" : "false");

    const listData = list.map((item, index) => ({
      last5Numbers: item.last5Numbers,
      amount: item.amount,
      imageIndex: item.images ? index : undefined,
    }));

    formData.append("list", JSON.stringify(listData));

    list.forEach((item, index) => {
      if (item.images) {
        if (item.images instanceof File) {
          formData.append(`image_${index}`, item.images, item.images.name);
        } else if (typeof item.images === "string" && item.images.length > 0) {
          const blob = base64ToBlob(item.images);
          formData.append(`image_${index}`, blob, `ticket_${index}.jpg`);
        }
      }
    });

    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/add-pair`,
      formData,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "multipart/form-data",
          Authorization: token,
        },
      },
    );

    if (response && response.status === 200) {
      return response.data || { success: true };
    }
    return { success: false, error: "Invalid response status" };
  } catch (error) {
    console.error("addPairStorage error:", error);
    // Extract error message from API response
    if (error.response && error.response.data) {
      const errorData = error.response.data;
      return {
        success: false,
        error: errorData.error || "Unknown error",
        message: errorData.message || error.message,
        duplicatePairs: errorData.duplicatePairs || [],
      };
    }
    return { success: false, error: error.message };
  }
};
